<template>

  <div :class="noBackground ? '' : 'bg-bordered'">

    <el-row v-if="st"justify="center" :gutter="12">

      <el-col v-if="showRequests && st.rta" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Acquire" icon="fa fa-street-view" :value="st.rta" color="goldenrod" :url="'/requests/acquire' + (orgId ? '/' + orgId : '')" no-plural />
      </el-col>

      <el-col v-if="showRequests && st.rts" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Share" icon="fa fa-share-alt" :value="st.rts" color="limegreen" :url="'/requests/share' + (orgId ? '/' + orgId : '')" />
      </el-col>

      <el-col v-if="showRequests && st.rtu" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Upgrade" icon="fa fa-tools" :value="st.rtu" color="dodgerblue"  :url="'/requests/upgrade' + (orgId ? '/' + orgId : '')" />
      </el-col>

      <el-col v-if="showRequests && st.rtb" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Backhaul" icon="fa fa-wifi" :value="st.rtb" color="grey"  :url="'/requests/backhaul' + (orgId ? '/' + orgId : '')" no-plural />
      </el-col>

      <el-col v-if="showRequests && st.permits" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  :caption="permitLabel" no-plural :value="st.permits" icon="fa fa-file-alt" color="slategrey" />
      </el-col>

      <el-col v-if="!showOnlyRequests && st.tickets" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Ticket" icon="fa fa-headset" :value="st.tickets" color="orange" :url="'/tickets'  + (orgId ? '/null/null/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && isTowerCo() && (st.ticketCritical)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Critical"  no-plural icon="fa fa-asterisk" :value="st.ticketCritical" color="indianred" :url="'/tickets/null/critical'  + (orgId ? '/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && isTowerCo() && (st.ticketUrgent)" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text  caption="Urgent"  no-plural icon="fa fa-chevron-up" :value="st.ticketUrgent" color="indianred" :url="'/tickets/null/urgent'  + (orgId ? '/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && st.ticketPending" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text caption="Pending"  no-plural :value="st.ticketPending" icon="fa fa-clock" color="lightgrey" :url="'/tickets/pending' + (orgId ? '/null/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && st.ticketOpen" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text caption="Open" no-plural :value="st.ticketOpen" icon="fa fa-folder-open" color="slategrey" :url="'/tickets/open' + (orgId ? '/null/' + orgId : '')" />
      </el-col>

      <el-col  v-if="!showOnlyRequests && st.ticketActive" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text caption="Active" no-plural :value="st.ticketActive" icon="fa fa-tasks" color="navy" :url="'/tickets/active' + (orgId ? '/null/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && st.ticketOverdue" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg"  align="center">
        <dash-text  caption="Overdue" no-plural :value="st.ticketOverdue"  icon="fa fa-hourglass-end" color="orange" :url="'/tickets/overdue' + (orgId ? '/null/' + orgId : '')" />
      </el-col>

      <el-col v-if="!showOnlyRequests && st.ticketClosed" :xs="media.xs" :sm="media.sm" :md="media.md" :lg="media.lg" align="center">
        <dash-text caption="Closed" no-plural :value="st.ticketClosed" icon="fa fa-folder" :url="'/tickets/completed-closed' + (orgId ? '/null/' + orgId : '')" />
      </el-col>

    </el-row>

<p></p>

</div>

</template>

<script>

import {settings} from '@/components/Data'

export default {

  props: {

    showRequests: {
      type: Boolean,
      default: true
    },

    showOnlyRequests: {
      type: Boolean,
      default: false
    },

    noBackground: {
      type: Boolean,
      default: false
    },

    stats: {
      type: Object,
      default: null
    },

    orgId: {
      type: Number,
      default: null
    }

  },

  watch: {

    orgId: function(id) {
      this.orgId = id
      this.st = this.getStats(this.orgid, true)
    },

    stats: function (stats) {
      this.st = stats
    }

  },

  data () {
    return {
      media: {xs: 12, sm: 12, md: 6, lg: 4},
      permitLabel: settings.permitLabel,
      st: this.getStats(),
      orgid: this.orgId ? this.orgId : this.profile().organisation_id
    }
  },

  created () {

    if (!this.stats) {
      this.st = this.getStats(this.orgid, true)
    } else {
      this.st = this.stats
    }

  }
}
</script>
